import script from "./DetailedLeadershipCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedLeadershipCard.vue?vue&type=script&setup=true&lang=js"

import "./DetailedLeadershipCard.vue?vue&type=style&index=0&id=05c0c7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c0c7d8"]])

export default __exports__